// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminOrgApiKeysIssueData, AdminOrgApiKeysIssueErrors, AdminOrgApiKeysIssueResponses, AdminOrgApiKeysListData, AdminOrgApiKeysListErrors, AdminOrgApiKeysListResponses, AdminOrgApiKeysRevokeData, AdminOrgApiKeysRevokeErrors, AdminOrgApiKeysRevokeResponses, AdminOrgsCreateData, AdminOrgsCreateErrors, AdminOrgsCreateResponses, AdminOrgsDeleteData, AdminOrgsDeleteErrors, AdminOrgsDeleteResponses, AdminOrgsGetData, AdminOrgsGetErrors, AdminOrgsGetResponses, AdminOrgsListData, AdminOrgsListErrors, AdminOrgsListResponses, AdminOrgsUpdateData, AdminOrgsUpdateErrors, AdminOrgsUpdateResponses, AdminPlatformApiKeysIssueData, AdminPlatformApiKeysIssueErrors, AdminPlatformApiKeysIssueResponses, AdminPlatformApiKeysListData, AdminPlatformApiKeysListErrors, AdminPlatformApiKeysListResponses, AdminPlatformApiKeysRevokeData, AdminPlatformApiKeysRevokeErrors, AdminPlatformApiKeysRevokeResponses, AgentCatalogReportData, AgentCatalogReportErrors, AgentCatalogReportResponses, AgentCatalogSyncData, AgentCatalogSyncErrors, AgentCatalogSyncResponses, AgentCompleteData, AgentCompleteErrors, AgentCompleteResponses, AgentEnrollData, AgentEnrollErrors, AgentEnrollResponses, AgentFailData, AgentFailErrors, AgentFailResponses, AgentHeartbeatData, AgentHeartbeatErrors, AgentHeartbeatResponses, AgentHostReportData, AgentHostReportErrors, AgentHostReportResponses, AgentLeaseData, AgentLeaseErrors, AgentLeaseResponses, AgentReconcileReportData, AgentReconcileReportErrors, AgentReconcileReportResponses, AgentRenewData, AgentRenewErrors, AgentRenewResponses, AgentSyncData, AgentSyncErrors, AgentSyncResponses, AuthAdminLoginData, AuthAdminLoginErrors, AuthAdminLoginResponses, AuthLoginData, AuthLoginErrors, AuthLoginResponses, AuthLogoutData, AuthLogoutErrors, AuthLogoutResponses, AuthMeData, AuthMeErrors, AuthMeResponses, AuthRefreshData, AuthRefreshErrors, AuthRefreshResponses, AuthRegisterData, AuthRegisterErrors, AuthRegisterResponses, BillingProvisionData, BillingProvisionErrors, BillingProvisionResponses, BillingSuspendData, BillingSuspendErrors, BillingSuspendResponses, BillingTerminateData, BillingTerminateErrors, BillingTerminateResponses, BillingUnsuspendData, BillingUnsuspendErrors, BillingUnsuspendResponses, HealthData, HealthErrors, HealthResponses, LairsCreateData, LairsCreateErrors, LairsCreateResponses, LairsDeleteData, LairsDeleteErrors, LairsDeleteResponses, LairsGetData, LairsGetErrors, LairsGetResponses, LairsListData, LairsListErrors, LairsListResponses, LairsReconcileStatusData, LairsReconcileStatusErrors, LairsReconcileStatusResponses, LairsUpdateData, LairsUpdateErrors, LairsUpdateResponses, OsImagesCreateData, OsImagesCreateErrors, OsImagesCreateResponses, OsImagesDeleteData, OsImagesDeleteErrors, OsImagesDeleteResponses, OsImagesGetData, OsImagesGetErrors, OsImagesGetResponses, OsImagesListData, OsImagesListErrors, OsImagesListResponses, OsImagesUpdateData, OsImagesUpdateErrors, OsImagesUpdateResponses, PlansCreateData, PlansCreateErrors, PlansCreateResponses, PlansDeleteData, PlansDeleteErrors, PlansDeleteResponses, PlansGetData, PlansGetErrors, PlansGetResponses, PlansListData, PlansListErrors, PlansListResponses, PlansUpdateData, PlansUpdateErrors, PlansUpdateResponses, ServersCreateData, ServersCreateErrors, ServersCreateResponses, ServersDestroyData, ServersDestroyErrors, ServersDestroyResponses, ServersGetData, ServersGetErrors, ServersGetResponses, ServersListData, ServersListErrors, ServersListResponses, ServersRebootData, ServersRebootErrors, ServersRebootResponses, ServersStartData, ServersStartErrors, ServersStartResponses, ServersStopData, ServersStopErrors, ServersStopResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List platform-level API keys (admin overview).
 *
 * Platform-level keys (those with organization_id IS NULL) authenticate non-tenant integrations such as the Blesta module.
 */
export const adminPlatformApiKeysList = <ThrowOnError extends boolean = false>(options?: Options<AdminPlatformApiKeysListData, ThrowOnError>) => (options?.client ?? client).get<AdminPlatformApiKeysListResponses, AdminPlatformApiKeysListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/api-keys',
    ...options
});

/**
 * Issue a new platform-level API key (admin).
 *
 * Returns the PLAINTEXT token in the response body — this is the ONLY time it is ever shown. The caller (a UI showing it to the operator) MUST capture it now; lose it and the only recovery is to revoke this key and issue a new one. The hash of the plaintext is what's stored server-side.
 */
export const adminPlatformApiKeysIssue = <ThrowOnError extends boolean = false>(options: Options<AdminPlatformApiKeysIssueData, ThrowOnError>) => (options.client ?? client).post<AdminPlatformApiKeysIssueResponses, AdminPlatformApiKeysIssueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a platform-level API key (admin).
 */
export const adminPlatformApiKeysRevoke = <ThrowOnError extends boolean = false>(options: Options<AdminPlatformApiKeysRevokeData, ThrowOnError>) => (options.client ?? client).delete<AdminPlatformApiKeysRevokeResponses, AdminPlatformApiKeysRevokeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/api-keys/{key_id}',
    ...options
});

/**
 * List all organizations (admin).
 */
export const adminOrgsList = <ThrowOnError extends boolean = false>(options?: Options<AdminOrgsListData, ThrowOnError>) => (options?.client ?? client).get<AdminOrgsListResponses, AdminOrgsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs',
    ...options
});

/**
 * Create a new organization (admin).
 *
 * If slug is omitted, it's generated from the name. v0 limitation: a slug collision returns an error — choose a different name or pass an explicit slug.
 */
export const adminOrgsCreate = <ThrowOnError extends boolean = false>(options: Options<AdminOrgsCreateData, ThrowOnError>) => (options.client ?? client).post<AdminOrgsCreateResponses, AdminOrgsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete an organization (admin).
 */
export const adminOrgsDelete = <ThrowOnError extends boolean = false>(options: Options<AdminOrgsDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminOrgsDeleteResponses, AdminOrgsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs/{id}',
    ...options
});

/**
 * Fetch an organization by id (admin).
 */
export const adminOrgsGet = <ThrowOnError extends boolean = false>(options: Options<AdminOrgsGetData, ThrowOnError>) => (options.client ?? client).get<AdminOrgsGetResponses, AdminOrgsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs/{id}',
    ...options
});

/**
 * Update an existing organization (admin).
 */
export const adminOrgsUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminOrgsUpdateData, ThrowOnError>) => (options.client ?? client).patch<AdminOrgsUpdateResponses, AdminOrgsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List org-scoped API keys for an organization (admin).
 */
export const adminOrgApiKeysList = <ThrowOnError extends boolean = false>(options: Options<AdminOrgApiKeysListData, ThrowOnError>) => (options.client ?? client).get<AdminOrgApiKeysListResponses, AdminOrgApiKeysListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs/{id}/api-keys',
    ...options
});

/**
 * Issue a new org-scoped API key (admin).
 *
 * Returns the PLAINTEXT token in the response body — this is the ONLY time it is ever shown. The caller (a UI showing it to the operator) MUST capture it now; lose it and the only recovery is to revoke this key and issue a new one. The hash of the plaintext is what's stored server-side.
 */
export const adminOrgApiKeysIssue = <ThrowOnError extends boolean = false>(options: Options<AdminOrgApiKeysIssueData, ThrowOnError>) => (options.client ?? client).post<AdminOrgApiKeysIssueResponses, AdminOrgApiKeysIssueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs/{id}/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke an org-scoped API key (admin).
 */
export const adminOrgApiKeysRevoke = <ThrowOnError extends boolean = false>(options: Options<AdminOrgApiKeysRevokeData, ThrowOnError>) => (options.client ?? client).delete<AdminOrgApiKeysRevokeResponses, AdminOrgApiKeysRevokeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/orgs/{id}/api-keys/{key_id}',
    ...options
});

/**
 * Report the agent's catalog mirror freshness.
 */
export const agentCatalogReport = <ThrowOnError extends boolean = false>(options: Options<AgentCatalogReportData, ThrowOnError>) => (options.client ?? client).post<AgentCatalogReportResponses, AgentCatalogReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/catalog-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pull the resource-catalog mirror snapshot (501 in v0).
 *
 * Deferred to chunk-3: same reason as /agent/sync.
 */
export const agentCatalogSync = <ThrowOnError extends boolean = false>(options?: Options<AgentCatalogSyncData, ThrowOnError>) => (options?.client ?? client).get<AgentCatalogSyncResponses, AgentCatalogSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/catalog-sync',
    ...options
});

/**
 * Mark a leased task as succeeded and report its output.
 */
export const agentComplete = <ThrowOnError extends boolean = false>(options: Options<AgentCompleteData, ThrowOnError>) => (options.client ?? client).post<AgentCompleteResponses, AgentCompleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enroll a Lair-side agent and mint an access token bundle.
 *
 * Verifies the (lair_id, org_key, org_secret) bootstrap credentials provisioned with the lair and returns an agent-scoped JWT bundle. No prior auth is required because this IS the auth flow.
 */
export const agentEnroll = <ThrowOnError extends boolean = false>(options: Options<AgentEnrollData, ThrowOnError>) => (options.client ?? client).post<AgentEnrollResponses, AgentEnrollErrors, ThrowOnError>({
    url: '/agent/enroll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a leased task as failed and report the error.
 */
export const agentFail = <ThrowOnError extends boolean = false>(options: Options<AgentFailData, ThrowOnError>) => (options.client ?? client).post<AgentFailResponses, AgentFailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/fail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Extend the lease window on an in-flight task.
 */
export const agentHeartbeat = <ThrowOnError extends boolean = false>(options: Options<AgentHeartbeatData, ThrowOnError>) => (options.client ?? client).post<AgentHeartbeatResponses, AgentHeartbeatErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report the lair's hypervisor / cpu / memory / disk / network snapshot.
 */
export const agentHostReport = <ThrowOnError extends boolean = false>(options: Options<AgentHostReportData, ThrowOnError>) => (options.client ?? client).post<AgentHostReportResponses, AgentHostReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/host-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lease the next pending task for the calling lair.
 *
 * Returns task_id == nil when there's no work. v0 polls every poll_after_sec seconds; long-poll is a chunk-3 deferred enhancement.
 */
export const agentLease = <ThrowOnError extends boolean = false>(options?: Options<AgentLeaseData, ThrowOnError>) => (options?.client ?? client).get<AgentLeaseResponses, AgentLeaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/lease',
    ...options
});

/**
 * Report reconcile generation + per-resource status (per-resource ignored in v0).
 */
export const agentReconcileReport = <ThrowOnError extends boolean = false>(options: Options<AgentReconcileReportData, ThrowOnError>) => (options.client ?? client).post<AgentReconcileReportResponses, AgentReconcileReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/reconcile-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exchange an agent refresh token for a new bundle.
 *
 * Looks up the supplied refresh token's TokenSession (must have been minted by /agent/enroll), revokes it, and mints a fresh access+refresh pair bound to the same lair. Returns 401 if the token is unknown, expired, revoked, or was minted for a non-agent principal.
 */
export const agentRenew = <ThrowOnError extends boolean = false>(options: Options<AgentRenewData, ThrowOnError>) => (options.client ?? client).post<AgentRenewResponses, AgentRenewErrors, ThrowOnError>({
    url: '/agent/renew',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pull the desired-state generation snapshot for this lair.
 *
 * Returns the latest published LairDesiredGeneration for the calling agent's lair plus the full LairDesiredResource list. When the agent's CurrentGeneration matches the latest, returns no resources and a longer PollAfterSec.
 */
export const agentSync = <ThrowOnError extends boolean = false>(options: Options<AgentSyncData, ThrowOnError>) => (options.client ?? client).get<AgentSyncResponses, AgentSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agent/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Platform staff login (email + password).
 */
export const authAdminLogin = <ThrowOnError extends boolean = false>(options: Options<AuthAdminLoginData, ThrowOnError>) => (options.client ?? client).post<AuthAdminLoginResponses, AuthAdminLoginErrors, ThrowOnError>({
    url: '/auth/admin/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Customer login (email + password).
 */
export const authLogin = <ThrowOnError extends boolean = false>(options: Options<AuthLoginData, ThrowOnError>) => (options.client ?? client).post<AuthLoginResponses, AuthLoginErrors, ThrowOnError>({
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a refresh-token session.
 */
export const authLogout = <ThrowOnError extends boolean = false>(options: Options<AuthLogoutData, ThrowOnError>) => (options.client ?? client).post<AuthLogoutResponses, AuthLogoutErrors, ThrowOnError>({
    url: '/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return the currently authenticated principal.
 */
export const authMe = <ThrowOnError extends boolean = false>(options?: Options<AuthMeData, ThrowOnError>) => (options?.client ?? client).get<AuthMeResponses, AuthMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/me',
    ...options
});

/**
 * Exchange a refresh token for a new token bundle.
 */
export const authRefresh = <ThrowOnError extends boolean = false>(options: Options<AuthRefreshData, ThrowOnError>) => (options.client ?? client).post<AuthRefreshResponses, AuthRefreshErrors, ThrowOnError>({
    url: '/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register a new customer user, either joining an existing org or creating one.
 *
 * Pass org_id to join an existing organization as a member. Pass org_name to create a new organization (the registering user becomes its owner). Exactly one of the two must be supplied — if neither is set the request is rejected with 400.
 */
export const authRegister = <ThrowOnError extends boolean = false>(options: Options<AuthRegisterData, ThrowOnError>) => (options.client ?? client).post<AuthRegisterResponses, AuthRegisterErrors, ThrowOnError>({
    url: '/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provision a VM for a paid Blesta service. Idempotent on blesta_service_id.
 */
export const billingProvision = <ThrowOnError extends boolean = false>(options: Options<BillingProvisionData, ThrowOnError>) => (options.client ?? client).post<BillingProvisionResponses, BillingProvisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/billing/provision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Terminate (destroy) the VM for a cancelled Blesta service.
 */
export const billingTerminate = <ThrowOnError extends boolean = false>(options: Options<BillingTerminateData, ThrowOnError>) => (options.client ?? client).delete<BillingTerminateResponses, BillingTerminateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/billing/services/{service_id}',
    ...options
});

/**
 * Suspend a Blesta-tracked service (e.g. on overdue invoice).
 */
export const billingSuspend = <ThrowOnError extends boolean = false>(options: Options<BillingSuspendData, ThrowOnError>) => (options.client ?? client).post<BillingSuspendResponses, BillingSuspendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/billing/services/{service_id}/suspend',
    ...options
});

/**
 * Unsuspend a previously suspended Blesta service.
 */
export const billingUnsuspend = <ThrowOnError extends boolean = false>(options: Options<BillingUnsuspendData, ThrowOnError>) => (options.client ?? client).post<BillingUnsuspendResponses, BillingUnsuspendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/billing/services/{service_id}/unsuspend',
    ...options
});

/**
 * Liveness check
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) => (options?.client ?? client).get<HealthResponses, HealthErrors, ThrowOnError>({ url: '/health', ...options });

/**
 * List all hypervisor hosts (admin).
 */
export const lairsList = <ThrowOnError extends boolean = false>(options?: Options<LairsListData, ThrowOnError>) => (options?.client ?? client).get<LairsListResponses, LairsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lairs',
    ...options
});

/**
 * Register a new hypervisor host (admin).
 *
 * Creates a Lair record and mints fresh bootstrap credentials (org_key + org_secret). The plaintext org_secret is returned ONCE in the response — display it to the operator immediately and never persist it server-side. The operator pastes the returned operator_snippet on the hypervisor to install and enroll the agent.
 */
export const lairsCreate = <ThrowOnError extends boolean = false>(options: Options<LairsCreateData, ThrowOnError>) => (options.client ?? client).post<LairsCreateResponses, LairsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lairs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete a lair (admin).
 */
export const lairsDelete = <ThrowOnError extends boolean = false>(options: Options<LairsDeleteData, ThrowOnError>) => (options.client ?? client).delete<LairsDeleteResponses, LairsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lairs/{id}',
    ...options
});

/**
 * Fetch a lair by id (admin).
 */
export const lairsGet = <ThrowOnError extends boolean = false>(options: Options<LairsGetData, ThrowOnError>) => (options.client ?? client).get<LairsGetResponses, LairsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lairs/{id}',
    ...options
});

/**
 * Update an existing lair (admin).
 */
export const lairsUpdate = <ThrowOnError extends boolean = false>(options: Options<LairsUpdateData, ThrowOnError>) => (options.client ?? client).patch<LairsUpdateResponses, LairsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lairs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List per-resource reconcile status for a lair (admin).
 *
 * Returns one row per (resource_type, resource_id) reflecting the agent's most recent reconcile report. Use this to see the converged/degraded breakdown beyond the rolled-up summary.
 */
export const lairsReconcileStatus = <ThrowOnError extends boolean = false>(options: Options<LairsReconcileStatusData, ThrowOnError>) => (options.client ?? client).get<LairsReconcileStatusResponses, LairsReconcileStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lairs/{id}/reconcile-status',
    ...options
});

/**
 * List active OS images.
 *
 * Returns only images where is_active=true. Used by customers picking a base OS at server-creation time.
 */
export const osImagesList = <ThrowOnError extends boolean = false>(options?: Options<OsImagesListData, ThrowOnError>) => (options?.client ?? client).get<OsImagesListResponses, OsImagesListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/os-images',
    ...options
});

/**
 * Create a new OS image (admin).
 */
export const osImagesCreate = <ThrowOnError extends boolean = false>(options: Options<OsImagesCreateData, ThrowOnError>) => (options.client ?? client).post<OsImagesCreateResponses, OsImagesCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/os-images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete an OS image (admin).
 */
export const osImagesDelete = <ThrowOnError extends boolean = false>(options: Options<OsImagesDeleteData, ThrowOnError>) => (options.client ?? client).delete<OsImagesDeleteResponses, OsImagesDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/os-images/{id}',
    ...options
});

/**
 * Fetch an OS image by id.
 */
export const osImagesGet = <ThrowOnError extends boolean = false>(options: Options<OsImagesGetData, ThrowOnError>) => (options.client ?? client).get<OsImagesGetResponses, OsImagesGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/os-images/{id}',
    ...options
});

/**
 * Update an existing OS image (admin).
 */
export const osImagesUpdate = <ThrowOnError extends boolean = false>(options: Options<OsImagesUpdateData, ThrowOnError>) => (options.client ?? client).patch<OsImagesUpdateResponses, OsImagesUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/os-images/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List active plans visible to the caller.
 *
 * Returns only plans where is_active=true. Customers and admins both call this; admins see the full catalog via the same endpoint because v0 does not gate inactive plans separately.
 */
export const plansList = <ThrowOnError extends boolean = false>(options?: Options<PlansListData, ThrowOnError>) => (options?.client ?? client).get<PlansListResponses, PlansListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/plans',
    ...options
});

/**
 * Create a new plan (admin).
 */
export const plansCreate = <ThrowOnError extends boolean = false>(options: Options<PlansCreateData, ThrowOnError>) => (options.client ?? client).post<PlansCreateResponses, PlansCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete a plan (admin).
 */
export const plansDelete = <ThrowOnError extends boolean = false>(options: Options<PlansDeleteData, ThrowOnError>) => (options.client ?? client).delete<PlansDeleteResponses, PlansDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/plans/{id}',
    ...options
});

/**
 * Fetch a plan by id.
 */
export const plansGet = <ThrowOnError extends boolean = false>(options: Options<PlansGetData, ThrowOnError>) => (options.client ?? client).get<PlansGetResponses, PlansGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/plans/{id}',
    ...options
});

/**
 * Update an existing plan (admin).
 */
export const plansUpdate = <ThrowOnError extends boolean = false>(options: Options<PlansUpdateData, ThrowOnError>) => (options.client ?? client).patch<PlansUpdateResponses, PlansUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/plans/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List servers visible to the caller.
 *
 * Customers see their own organization's servers; admins see all servers.
 */
export const serversList = <ThrowOnError extends boolean = false>(options?: Options<ServersListData, ThrowOnError>) => (options?.client ?? client).get<ServersListResponses, ServersListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/servers',
    ...options
});

/**
 * Provision a new server.
 *
 * Customer flow: org and owner come from the access token; the body must omit org_id / owner_user_id / lair_id (or supply matching values — mismatches are rejected). Admin flow: org_id and owner_user_id are required in the body, and lair_id may be set to pin the new server to a specific hypervisor host.
 */
export const serversCreate = <ThrowOnError extends boolean = false>(options: Options<ServersCreateData, ThrowOnError>) => (options.client ?? client).post<ServersCreateResponses, ServersCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/servers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy and soft-delete a server.
 *
 * Asks the driver to terminate the VM, marks state=terminated and desired_state=terminated, and soft-deletes the row.
 */
export const serversDestroy = <ThrowOnError extends boolean = false>(options: Options<ServersDestroyData, ThrowOnError>) => (options.client ?? client).delete<ServersDestroyResponses, ServersDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/servers/{id}',
    ...options
});

/**
 * Fetch a server by id.
 *
 * Customers can only fetch servers in their own organization; admins can fetch any. A cross-tenant id returns 404 (not 403) to avoid leaking the existence of foreign rows.
 */
export const serversGet = <ThrowOnError extends boolean = false>(options: Options<ServersGetData, ThrowOnError>) => (options.client ?? client).get<ServersGetResponses, ServersGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/servers/{id}',
    ...options
});

/**
 * Reboot a server.
 *
 * Pass {"force": true} to ask for a hard reset; the default is a graceful reboot.
 */
export const serversReboot = <ThrowOnError extends boolean = false>(options: Options<ServersRebootData, ThrowOnError>) => (options.client ?? client).post<ServersRebootResponses, ServersRebootErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/servers/{id}/reboot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start (power on) a server.
 */
export const serversStart = <ThrowOnError extends boolean = false>(options: Options<ServersStartData, ThrowOnError>) => (options.client ?? client).post<ServersStartResponses, ServersStartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/servers/{id}/start',
    ...options
});

/**
 * Stop (power off) a server.
 *
 * Pass {"force": true} to request a hard power-off; the default is a graceful ACPI shutdown.
 */
export const serversStop = <ThrowOnError extends boolean = false>(options: Options<ServersStopData, ThrowOnError>) => (options.client ?? client).post<ServersStopResponses, ServersStopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/servers/{id}/stop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
